import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { IrbStatus } from 'libs.irb.common';
import { Badge } from 'libs.nucleus';
import { DownloadReportAction } from './download_report_action.component';
import { ViewErrorLogAction } from './view_error_log_action.component';
// Memoized Status Cell Component
export const StatusCell = memo(({ status }) => {
    const getBadgeDisplayAttributes = (status) => {
        switch (status) {
            case IrbStatus.ENQUEUED:
                return { variant: 'incomplete', label: 'In queue' };
            case IrbStatus.PROCESSING:
                return { variant: 'incomplete', label: 'Processing...' };
            case IrbStatus.SUCCESS:
                return { variant: 'success', label: 'Succeeded' };
            case IrbStatus.FAILURE:
                return { variant: 'danger', label: 'Failed' };
            default:
                console.error('Oops! Unknown status:', status);
                return { variant: 'incomplete', label: 'In queue' };
        }
    };
    const { label, variant } = getBadgeDisplayAttributes(status);
    return _jsx(Badge, { variant: variant, label: label });
});
StatusCell.displayName = 'StatusCell';
// Memoized Action Cell Component
export const ActionCell = memo(({ status, locale, url, errorMessage, fileName, }) => {
    if (status === IrbStatus.SUCCESS && url) {
        return _jsx(DownloadReportAction, { url: url, fileName: fileName });
    }
    if (status === IrbStatus.FAILURE && errorMessage) {
        return _jsx(ViewErrorLogAction, { errorMessage: errorMessage, locale: locale });
    }
    return null;
});
ActionCell.displayName = 'ActionCell';
